import { useState } from 'react';
import { Marco, Fila, Pastilla } from './pantalla';

/* =====================================================================
   QUÉ HACE · una lista y una pantalla, no nueve tarjetas
   =====================================================================
   Eran NUEVE tarjetas con un párrafo cada una y una foto de banco de
   imágenes encima. Nadie lee nueve párrafos en una portada, y las fotos
   no decían nada del producto.

   Ahora: la lista de lo que hace a la izquierda —una línea por cosa— y a
   la derecha la pantalla que la enseña, dibujada. Se elige con el ratón
   o con el teclado; la imagen hace el trabajo que hacía el párrafo.
   ===================================================================== */

const QUE_HACE = [
  {
    clave: 'existencias',
    nombre: 'Inventario y existencias',
    dice: 'Cuánto hay de cada cosa, y aviso cuando queda poco.',
    titulo: 'Existencias · Matriz',
    pantalla: (
      <>
        <Fila izq="Cinta canela 48 mm" sub="CIN-048" der="240 pz" />
        <Fila izq="Guante nitrilo M" sub="GUA-NM" der="12 pz" tono="atencion" />
        <Fila izq="Cubeta 19 L" sub="CUB-19" der="86 pz" />
        <Fila izq="Filtro 10 µm" sub="FIL-010" der="31 pz" />
        <p className="mt-3 text-[0.75rem] text-[var(--p-brasa)]">
          Guante nitrilo M quedó por debajo de su mínimo (20). Se agregó a
          la lista de compras.
        </p>
      </>
    ),
  },
  {
    clave: 'ubicaciones',
    nombre: 'Almacén y ubicaciones',
    dice: 'En qué pasillo, en qué anaquel y en qué nivel está cada caja.',
    titulo: 'Ubicaciones · Pasillo 3',
    pantalla: (
      <>
        <div className="grid grid-cols-4 gap-1.5">
          {['A-1', 'A-2', 'A-3', 'A-4', 'B-1', 'B-2', 'B-3', 'B-4',
            'C-1', 'C-2', 'C-3', 'C-4'].map((u) => (
            <span key={u}
                  className={`rounded border px-1 py-2 text-center text-[0.6875rem] font-semibold tabular-nums ${
                    u === 'B-2'
                      ? 'border-[var(--p-marca)] text-white bg-[var(--p-marca-solido)]'
                      : 'border-[var(--p-linea)] text-[var(--p-tinta-3)]'}`}>
              {u}
            </span>
          ))}
        </div>
        <p className="mt-3 text-[0.75rem] text-[var(--p-tinta-3)]">
          Cinta canela 48 mm · <span className="text-[var(--p-tinta)] font-semibold">Pasillo 3, B-2</span> · 240 pz
        </p>
      </>
    ),
  },
  {
    clave: 'qr',
    nombre: 'Lectura de códigos',
    dice: 'Apuntas con el teléfono y queda anotado, con o sin red.',
    titulo: 'Escanear',
    pantalla: <PantallaCodigo />,
  },
  {
    clave: 'venta',
    nombre: 'Punto de venta',
    dice: 'Cobras y el inventario se descuenta solo.',
    titulo: 'Venta · ticket 1842',
    pantalla: (
      <>
        <Fila izq="Cubeta 19 L" sub="2 × $189.00" der="$378.00" />
        <Fila izq="Cinta canela 48 mm" sub="6 × $24.50" der="$147.00" />
        <div className="flex items-center justify-between pt-3 mt-1 border-t-2 border-[var(--p-tinta)]">
          <span className="text-[0.9375rem] font-semibold">Total</span>
          <span className="text-[1.125rem] font-semibold tabular-nums">$525.00</span>
        </div>
        <p className="mt-3 text-[0.75rem] text-[var(--p-bien)]">
          8 piezas descontadas del inventario de Matriz.
        </p>
      </>
    ),
  },
  {
    clave: 'escaparate',
    nombre: 'Escaparate',
    dice: 'Tu catálogo en una dirección que puedes mandar por mensaje.',
    titulo: 'Escaparate · bodegasdelnorte',
    pantalla: (
      <div className="grid grid-cols-3 gap-2.5">
        {[['Cubeta 19 L', '$189'], ['Cinta 48 mm', '$24.50'], ['Guante M', '$62']].map(([n, pr]) => (
          <div key={n} className="rounded border border-[var(--p-linea)] p-2">
            <div className="h-12 rounded bg-[var(--p-fondo-2)] border border-[var(--p-linea)]" aria-hidden="true" />
            <p className="mt-2 text-[0.6875rem] font-semibold leading-tight">{n}</p>
            <p className="text-[0.6875rem] text-[var(--p-tinta-3)] tabular-nums">{pr}</p>
          </div>
        ))}
      </div>
    ),
  },
  // FACTURACIÓN fuera del sitio hasta que exista el PAC · R-L11 (dueño,
  // 20 sep 2026). Prometer factura sin poder emitirla es el reclamo que no
  // se quiere del primer cliente que pague. La tarjeta vuelve cuando se
  // cierre R-L3; la pantalla de facturación del producto sigue existiendo.
  {
    clave: 'activos',
    nombre: 'Activos y personal',
    dice: 'Qué herramienta trae quién, y quién está en el turno.',
    titulo: 'Activos asignados',
    pantalla: (
      <>
        <Fila izq="Lector RF-220" sub="María Fernanda R." der="En turno" tono="bien" />
        <Fila izq="Montacargas 02" sub="Jorge A." der="En turno" tono="bien" />
        <Fila izq="Lector RF-118" sub="Sin asignar" der="En bodega" />
        <Fila izq="Tableta 07" sub="Luis M. · desde el 12 ago" der="Sin devolver" tono="atencion" />
      </>
    ),
  },
];

/* EL CÓDIGO SÍ ES UN `<svg>`: una retícula de módulos no se dibuja con
   `div` sin escribir 484 de ellos. Es nuestro, va en este archivo y no
   pide nada a nadie. El patrón está escrito y no sorteado: con
   `Math.random()` cambiaría en cada repintado. */
const MODULOS = [
  '111111101011000111111', '100000101101010100001', '101110100011110101110',
  '101110101100110101110', '101110100101010101110', '100000101010100100001',
  '111111101010101111111', '000000001101100000000', '110110110101011011011',
  '010001011010100100010', '111011001011011110110', '001000110100101000101',
  '110110101011010110110', '000000011010110010001', '111111101101011010101',
  '100000100101100110110', '101110101011010101010', '101110110100101011001',
  '101110101010110100110', '100000101101001011010', '111111100110101101011',
];

function PantallaCodigo() {
  const paso = 8;
  return (
    <div className="flex items-center gap-4">
      <svg viewBox={`0 0 ${21 * paso} ${21 * paso}`} className="w-28 h-28 shrink-0"
           role="presentation" aria-hidden="true" focusable="false">
        <rect width="100%" height="100%" fill="var(--p-superficie)" />
        {MODULOS.flatMap((fila, y) => fila.split('').map((m, x) => (
          m === '1'
            ? <rect key={`${x}-${y}`} x={x * paso} y={y * paso} width={paso}
                    height={paso} fill="var(--p-tinta)" />
            : null
        )))}
      </svg>
      <div className="min-w-0">
        <p className="text-[0.8125rem] font-semibold">Entrada registrada</p>
        <p className="mt-1 text-[0.75rem] text-[var(--p-tinta-3)]">
          Cinta canela 48 mm · 50 pz · Pasillo 3, B-2
        </p>
        <p className="mt-2 text-[0.75rem] text-[var(--p-bien)]">
          Sin red: se guardó en el teléfono y subió al volver la señal.
        </p>
      </div>
    </div>
  );
}

export default function QueHace() {
  const [activa, setActiva] = useState(0);
  const q = QUE_HACE[activa];

  return (
    <section id="soluciones" className="scroll-mt-20 border-b border-[var(--p-linea)]">
      <div className="mx-auto max-w-[76rem] px-6 py-20 lg:py-24">
        <div className="entra max-w-[46ch]">
          <p className="text-[0.8125rem] font-semibold uppercase tracking-[0.14em] text-[var(--p-tinta-3)]">
            Qué hace
          </p>
          <h2 className="mt-3 font-semibold tracking-[-0.02em] leading-[1.08] text-balance"
              style={{ fontSize: 'clamp(1.875rem, 3.4vw, 2.75rem)' }}>
            Todo lo que pasa en tu bodega, anotado.
          </h2>
        </div>

        <div className="entra mt-12 grid gap-8 lg:grid-cols-12 lg:gap-12" data-retardo="80">
          {/* LA LISTA · una línea por cosa. `radiogroup` y no botones
              sueltos: es UNA elección con siete valores, y un lector de
              pantalla tiene que poder decir «3 de 7». */}
          <div role="radiogroup" aria-label="Qué hace TEGO" className="lg:col-span-5">
            {QUE_HACE.map((x, i) => (
              <button
                key={x.clave}
                type="button"
                role="radio"
                aria-checked={i === activa}
                onClick={() => setActiva(i)}
                className={`block w-full text-left border-l-2 pl-4 py-3 transition-colors duration-150 ${
                  i === activa
                    ? 'border-[var(--p-marca)]'
                    : 'border-[var(--p-linea)] hover:border-[var(--p-linea-fuerte)]'}`}
              >
                <span className={`block text-[0.9375rem] font-semibold ${
                  i === activa ? 'text-[var(--p-tinta)]' : 'text-[var(--p-tinta-2)]'}`}>
                  {x.nombre}
                </span>
                <span className="block mt-0.5 text-[0.8125rem] leading-relaxed text-[var(--p-tinta-3)]">
                  {x.dice}
                </span>
              </button>
            ))}
          </div>

          <div className="lg:col-span-7">
            <Marco titulo={q.titulo}>{q.pantalla}</Marco>
            <p className="mt-3 text-[0.75rem] text-[var(--p-tinta-3)]">
              Pantallas de TEGO, dibujadas aquí mismo. Ni una imagen traída de fuera.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
